import { Phone, MessageCircle } from "lucide-react";
import { BRAND, telHref, waHref, LOGO_URL } from "@/lib/brand";
import { useEffect, useState } from "react";

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-nav"
            className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
                scrolled
                    ? "bg-white/90 backdrop-blur-md border-b border-black/10 shadow-sm"
                    : "bg-white/60 backdrop-blur-sm"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-3 flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="nav-logo"
                    className="flex items-center gap-3 group"
                >
                    <img
                        src={LOGO_URL}
                        alt="Stronger Solutions"
                        className="h-12 w-12 object-contain"
                    />
                    <div className="font-display font-bold text-base leading-none text-[#0a0a0a]">
                        STRONGER
                        <span className="block text-[10px] tracking-[0.3em] text-[#1E88E5] font-semibold mt-0.5">
                            SOLUTIONS
                        </span>
                    </div>
                </a>

                <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-700">
                    <a
                        href="#services"
                        className="hover:text-[#1E88E5] transition-colors"
                        data-testid="nav-services"
                    >
                        Services
                    </a>
                    <a
                        href="#results"
                        className="hover:text-[#1E88E5] transition-colors"
                        data-testid="nav-results"
                    >
                        Results
                    </a>
                    <a
                        href="#videos"
                        className="hover:text-[#1E88E5] transition-colors"
                        data-testid="nav-videos"
                    >
                        Videos
                    </a>
                    <a
                        href="#reviews"
                        className="hover:text-[#1E88E5] transition-colors"
                        data-testid="nav-reviews"
                    >
                        Reviews
                    </a>
                    <a
                        href="#contact"
                        className="hover:text-[#1E88E5] transition-colors"
                        data-testid="nav-contact"
                    >
                        Contact
                    </a>
                </nav>

                <div className="flex items-center gap-2">
                    <a
                        href={waHref}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="nav-whatsapp-btn"
                        className="hidden sm:flex h-10 w-10 items-center justify-center border border-black/10 hover:border-green-500 hover:bg-green-500/10 transition-colors rounded-sm"
                        aria-label="WhatsApp"
                    >
                        <MessageCircle className="w-4 h-4 text-green-600" />
                    </a>
                    <a
                        href={telHref}
                        data-testid="nav-call-btn"
                        className="flex items-center gap-2 bg-[#1E88E5] hover:bg-[#1976D2] text-white transition-colors px-4 py-2.5 rounded-sm text-sm font-bold uppercase tracking-wider"
                    >
                        <Phone className="w-4 h-4" />
                        <span className="hidden sm:inline">
                            {BRAND.phoneDisplay}
                        </span>
                        <span className="sm:hidden">Call</span>
                    </a>
                </div>
            </div>
        </header>
    );
}
